import React, { useContext } from 'react'
import { Box, Button, Dialog, DialogContent, TextField, Typography, useTheme } from '@mui/material';
import * as yup from "yup";
import { Formik } from "formik";
import { tokens } from '../theme';
import axios from 'axios';
import { UserContext } from '../context/UserContext';

function BrandLegalInfoDialog({ brandId, open, handleClose, onUpdate }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.colors);
    const { user, token } = useContext(UserContext);

    var initialValues = {
        legal_name: "",
        tax_no: "",
        company_address: "",
        company_phone_number: "",
        company_email: "",
        company_kep: "",
        return_email: "",
        return_address: "",
    }

    var shapeObject = {
        legal_name: yup.string().required("zorunlu"),
        tax_no: yup.string().required("zorunlu"),
        company_address: yup.string().required("zorunlu"),
        company_phone_number: yup.string().required("zorunlu"),
        company_email: yup.string().email("geçersiz email").required("zorunlu"),
        company_kep: yup.string().required("zorunlu"),
        return_email: yup.string().email("geçersiz email").required("zorunlu"),
        return_address: yup.string().required("zorunlu"),
    }

    const schema = yup.object().shape(shapeObject);

    const handleUpdate = (values) => {
        axios.patch(
            `${process.env.REACT_APP_API_URL}api/alcago/brand/updateBrand?token=${token}&brandId=${brandId}`,
            { brand: { ...values } }).catch(err => {
                console.error("Brand update error:", err);
            }).then(res => {
                if (res && res.data && res.data.status === 201) {
                    onUpdate(res.data);
                }
            });
    }

    return (
        <Dialog
            sx={{ margin: "0 auto" }}
            open={open}
            fullWidth
            maxWidth="md"
            onClose={handleClose}
        >
            <Box m="20px" mb="0" textAlign="center">
                <Typography variant='h3'>
                    Marka Yasal Bilgileri
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={(values) => {
                            handleUpdate(values);
                        }}
                        initialValues={initialValues}
                        validationSchema={schema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(3, minmax(0, 1fr))" mx="75px" my="25px">
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Yasal Firma Adı"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.legal_name}
                                        name="legal_name"
                                        error={!!touched.legal_name && !!errors.legal_name}
                                        helperText={touched.legal_name && errors.legal_name}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Vergi Numarası"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.tax_no}
                                        name="tax_no"
                                        error={!!touched.tax_no && !!errors.tax_no}
                                        helperText={touched.tax_no && errors.tax_no}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Firma Adresi"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.company_address}
                                        name="company_address"
                                        error={!!touched.company_address && !!errors.company_address}
                                        helperText={touched.company_address && errors.company_address}
                                        sx={{ gridColumn: "span 6" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Firma Telefon Numarası"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.company_phone_number}
                                        name="company_phone_number"
                                        error={!!touched.company_phone_number && !!errors.company_phone_number}
                                        helperText={touched.company_phone_number && errors.company_phone_number}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="email"
                                        label="Firma Eposta"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.company_email}
                                        name="company_email"
                                        error={!!touched.company_email && !!errors.company_email}
                                        helperText={touched.company_email && errors.company_email}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="email"
                                        label="Firma KEP Adresi"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.company_kep}
                                        name="company_kep"
                                        error={!!touched.company_kep && !!errors.company_kep}
                                        helperText={touched.company_kep && errors.company_kep}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="email"
                                        label="İade Eposta"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.return_email}
                                        name="return_email"
                                        error={!!touched.return_email && !!errors.return_email}
                                        helperText={touched.return_email && errors.return_email}
                                        sx={{ gridColumn: "span 3" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="İade Adresi"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.return_address}
                                        name="return_address"
                                        error={!!touched.return_address && !!errors.return_address}
                                        helperText={touched.return_address && errors.return_address}
                                        sx={{ gridColumn: "span 6" }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="center" m="20px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Kaydet</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default BrandLegalInfoDialog